import { api } from "@/services";

async function useAsyncModelsByBrand(brand: string): Promise<[Data: any[], NErro: string]> {
  let Data: any[] = null;
  let DError: string = null;

  if (!brand) {
    return [Data, "Nenhuma marca informada"];
  }

  const Controller = new AbortController();

  const MakeRequest = async () => {
    try {
      const resp = await api.get(`/Vehicles/GetVehiclesByBrand`, {
        signal: Controller.signal,
        params: {
          brand
        }
      });
      if (resp.data) {
        Data = resp.data;
      } else {
        DError = "Nenhum conteúdo encontrado";
      }
    } catch (Err) {
      DError = Err.message;
    }
  };

  await MakeRequest();

  Controller.abort();

  return [Data, DError];
}

export { useAsyncModelsByBrand };
